export const cleanCatify = () => {
  const catified = document.querySelectorAll("[class*=catified-]");
  catified.forEach(o => {
    for (let i = 0; i < 10; i++) {
      o.classList.remove("catified-" + i);
    }
  });
};

export const initCatify = () => {
  cleanCatify();
  const selectors = [
    //collection main image
    ".home-collection .row:first-child .col:first-child",
    ".collection-template-page-collectionarchives .item a",
    ".content_imgs",
    ".slide-to-catify",
    ".slide-zoomable",

    //news
    ".suki-loop .entry-wrapper",

    // logo
    ".suki-header-logo",
   
  ];

  const toCatify = document.querySelectorAll(selectors.join(","));

  toCatify.forEach(o => {
    const num = Math.ceil(Math.random() * 6);
    o.classList.add("catified-" + num);
  });
};

window.initCatify = initCatify;
setInterval(initCatify, 10000);
